import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  infoHeading: {
    textAlign: "center",
  },
  infoText: {
    textAlign: "left",
  },
  backButton: {
    position: "absolute",
    left: "30px",
    top: "20px",
    borderRadius: "8px",
    alignContent: "center",
    whiteSpace: "nowrap",
  },
  textField: {
    boxShadow: "4px 4px 4px 0px #0C38911A",
  },
}));
